module.exports = __webpack_public_path__ + "img/buy-eth.5ebe2a71.svg";